import React, { useState } from "react";
import { Button, Progress, UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap";
import { api } from "services/api";
import ProcessBox from "views/pages/components/custom/loader/processingLoader";
import "../uploadData/components/styles/style-duelist-upload-card.css";
import { readFile } from "@ramonak/react-excel";

const ImportationDetailsUpload = () => {
    const [fileData, setFileData] = useState(null);
    const [sheetName, setSheetName] = useState(null);
    const [excelData, setExcelData] = useState(null);
    const [loader, setLoader] = useState({ status: false, message: "" });
    const [uploadTime, setUploadTime] = useState({ time: 0, message: null, color: "default" });
    const [showFilteredModal, setShowFilteredModal] = useState(false);
    const [importedData, setImportedData] = useState({ results: [] });

    const handleOpenFilteredList = (data) => {
        setTimeout(() => {
            console.log("Abrindo modal para dados importados");
            setImportedData(data);
            setShowFilteredModal(true);
        }, 300)
    };

    const formatDate = (date) => {
        if (!date) return "-";

        try {
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        } catch {
            return "-";
        }
    };

    const formatStatusText = {
        updated: "✅ Updated",
        unchanged: "🟡 Unchanged",
        created: "✅ Created",
        created_not_in_duelist: "🟣 Created, Not Displayed",
        not_displayable: "❌ Not Displayable"
    };

    const handlerInputFile = async (e) => {
        setLoader({ status: true, message: "Carregando Planilha..."});
        setUploadTime({ time: 0, message: null, color: "default"});
        setSheetName("");

        if (e.target.files.length > 0) {
            const file = e.target.files[0];
            file.format = file.name.split('.');
            setFileData(file);

            try {
                const data = await readFile(file);
                setExcelData({ sheets: data.SheetNames });
                setLoader({ status: false, message: "" });
            } catch (error) {
                console.error(error);
                setLoader({ status: false, message: "" })
            }
        }
    };

    const handlerInputRadio = (e) => {
        if (e.target.checked) {
            setSheetName(e.target.value);
        }
    };

    const sendExcelFile = () => {
        if (!fileData) return alert("Select a Excel File");
        if (!sheetName) return alert("Select the Correct Sheet");

        const endpoint = `/upload/itatiba/${sheetName}/`;

        const formData = new FormData();
        formData.append("file", fileData);

        api.post(endpoint, formData, {
            onUploadProgress: (event) => {
                const progress = Math.round((event.loaded * 100 / event.total));
                if (progress === 100) {
                    setUploadTime({ time: 99, message: "Saving Data...", color: "alert"});
                    return setLoader({status: true, message: "Processing Data..."});
                }
                setUploadTime({ ...uploadTime, time: progress});
            },
        })
        .then((res) => {
            setUploadTime({time: 100, message: "Upload Complete", color: "success"});
            setLoader({status: false, message: ""});
            // alert(res.data.status || "Importation Complete");

            handleOpenFilteredList({
                resultados: res.data.results || []
            });
        })
        .catch((err) => {
            console.error(err);
            setUploadTime({time: 100, message: "Upload Error", color: "danger"});
            setLoader({status: false, message: ""});

            const response = err?.response?.data;
            if (response?.error) return alert(response.error);
            alert("Undefined Error, Call the Support");
        });
    };

    return (
        <>
            {loader.status ? (
                <ProcessBox message={loader.message} />
            ) : (
                <div className="duelist-upload-container-card">
                    <div className="duelist-upload-card">
                        <label htmlFor="file-seletor" className="duelist-upload-card-label">
                            Click to Upload
                            <div className="ni ni-send duelist-upload-card-icon" />
                        </label>
                        <div className="duelist-upload-card-title">File Name:</div>
                        <div className="duelist-upload-card-value" id="file-target">
                            {fileData ? fileData.name : "No excel selected."}
                        </div>
                        <UncontrolledTooltip placement="right" target="file-target">
                            {fileData ? fileData.name : "No excel selected."}
                        </UncontrolledTooltip>

                        <div className="duelist-upload-card-title">Sheets:</div>
                        <div className="duelist-upload-card-container-sheets">
                            <div className="duelist-upload-card-group-sheets">
                                {excelData?.sheets?.map((sheet, index) => (
                                    <div key={`sheet-${index}`} className="duelist-upload-card-sheet-item">
                                        <input
                                            type="radio"
                                            onChange={handlerInputRadio}
                                            id={`sheet-${index}`}
                                            value={sheet}
                                            className="duelist-upload-card-sheet-radio"
                                        />
                                        <label htmlFor={`sheet-${index}`} className="duelist-upload-card-sheet-label">
                                            {sheet}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="duelist-upload-card-container-progress">
                            <div className="progress-info">
                                <div className="progress-percentage">
                                    <span>{uploadTime.message ?? uploadTime.time}</span>
                                </div>
                            </div>
                            <Progress max="100" value={uploadTime.time} color={uploadTime.color} />
                        </div>
                        <input
                            type="file"
                            id="file-seletor"
                            onChange={handlerInputFile}
                            className="duelist-upload-card-input-file"
                            accept=".xlsx, .xls"
                        />
                    </div>
                    <Button color="primary" onClick={sendExcelFile}>
                        Send excel file
                    </Button>
                </div>
            )}

            {/* Modal para exibir dados importados */}
            {showFilteredModal && (
                <Modal isOpen={showFilteredModal} toggle={() => setShowFilteredModal(false)} size="lg" style={{ width: '70%', maxWidth: '1200px', maxHeight: '85vh', overflowY: 'auto' }}>
                    <ModalHeader toggle={() => setShowFilteredModal(false)}>Importation Details - Upload</ModalHeader>
                    <ModalBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Doc SAP</th>
                                    <th>IMP</th>
                                    <th>ETA Trianon</th>
                                    <th>Released to Invoice</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {importedData.resultados?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.docSap}</td>
                                        <td>{item.imp}</td>
                                        <td>{formatDate(item.prevChegadaTrianon)}</td>
                                        <td>{item.liberadoFaturamento ? "Yes" : "No"}</td>
                                        <td>{formatStatusText[item.status] || "❓ Unknown"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ModalBody>
                    {/* <ModalFooter>
                        <Button color="secondary" onClick={() => setShowFilteredModal(false)}>
                            Close
                        </Button>
                    </ModalFooter> */}
                </Modal>
            )}
        </>
    );
};

export default ImportationDetailsUpload;